import React from 'react'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'

import ErrorMessage from 'components/ErrorMessage'

import { color } from 'styles/colors'

const propTypes = {
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  listId: PropTypes.string,
  checked: PropTypes.oneOf(['indeterminate', true, false]),
  className: PropTypes.string,
  errorMessage: PropTypes.string,
  disabled: PropTypes.bool
}

const defaultProps = {
  checked: false,
  className: '',
  listId: '',
  errorMessage: '',
  disabled: false
}

const Checkbox = ({ checked, onChange, label, listId, className, errorMessage, disabled = false }) => {
  const id = label.replace(' ', '_') + listId
  const labelArray = label.split(/<\/?span>/)

  return (
    <S.Checkbox {...{ className }}>
      <S.Input {...{ checked, onChange, id, disabled }}
        ref={input => {
          if (input) {
            input.indeterminate = checked === 'indeterminate'
            input.checked = input.indeterminate ? false : checked
          }
        }}
        type="checkbox"
      />
      {labelArray.length > 1
        ? (
          <S.Label htmlFor={id} disabled={disabled}>
            {labelArray.map((label, i) => {
              /* eslint-disable react/no-array-index-key */
              if (label.includes(':-*/')) {
                return <S.FilteredLabel key={label + id + i}>{label.replace(':-*/', '')}</S.FilteredLabel>
              }
              return <React.Fragment key={label + id + i}>{label}</React.Fragment>
              /* eslint-enable react/no-array-index-key */
            })}
          </S.Label>
        )
        : <S.Label htmlFor={id} disabled={disabled}>{labelArray[0]}</S.Label>
      }
      <S.ErrorMessage errorMessage={errorMessage} />
    </S.Checkbox>
  )
}

Checkbox.propTypes = propTypes
Checkbox.defaultProps = defaultProps

export default Checkbox

const S = {
  Checkbox: styled.div`
    display: flex;
    justify-content: flex-start;
    font-weight: inherit;
    align-items: flex-start;
    margin-bottom: 7px;
  `,
  Input: styled.input`
    margin-top: 3px;
    margin-right: 7px;
    cursor: pointer;
  `,
  Label: styled.label`
    ${({ disabled }) => disabled ? css`
      color: ${color('disabledText')};
      cursor: default;
    ` : ''}
    line-height: 1.3;
    cursor: pointer;
  `,
  FilteredLabel: styled.span`
    background-color: ${color('filteredText')};
    font-weight: 700;
  `,
  ErrorMessage: styled(ErrorMessage)`
    margin-left: auto;
    cursor: pointer;
  `
}
